var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-controller-component"}},[_c('a',{ref:"btn-jump",attrs:{"href":"#","id":"btn-jump"},on:{"touchstart":_vm.jump}},[_c('img',{attrs:{"src":_vm.$url + 'img/pular_bt.png'}})])])}
var staticRenderFns = []

export { render, staticRenderFns }